export default __webpack_public_path__ + "img/sideselects-ee116466.png";